import { GraphQLError } from 'graphql';
import { Operation } from '@apollo/client/core';

export function buildApolloErrorPayload(
  operation: Operation,
  uri: string,
  details: {
    graphQLErrors?: readonly GraphQLError[];
    networkError?: any;
  }
): {
  message: string;
  operationName: string;
  uri: string;
  variables: any;
  query: string;
  errors?: Partial<GraphQLError>[];
  networkError?: any;
  summary?: string
  type: 'GraphQL' | 'Network';
} {
  const query = operation.query?.loc?.source?.body || 'Query source not available';

  const type = details.graphQLErrors ? 'GraphQL' : 'Network';

  const payload: any = {
    message: `${type} error during ${operation.operationName}`,
    operationName: operation.operationName,
    uri,
    variables: operation.variables,
    query,
    type,
  };

  if (type === 'GraphQL' && details.graphQLErrors) {
    payload.errors = details.graphQLErrors.map(({ message, locations, path, extensions }) => ({
      message,
      locations,
      path,
      extensions,
    }));

    const summary = details.graphQLErrors.map(e =>
      `Message: ${e.message}, Path: ${e.path?.join('.')}, Extensions: ${JSON.stringify(e.extensions)}`
    ).join('\n');

    payload.message = `${payload.message}\n${summary}`;
    payload.summary = summary;
  }

  if (type === 'Network' && details.networkError) {
    payload.networkError = {
      name: details.networkError.name,
      message: details.networkError.message,
      status: details.networkError.status,
      statusText: details.networkError.statusText,
      url: details.networkError.url,
      error: details.networkError.error,
    };
  }

  return payload;
}
